import { BrowserRouter } from "react-router-dom";
import { Notifications } from "@mantine/notifications";
import AppRoutes from "./routes";
import { UserProvider } from "@/context/UserContext";
import { NotificationProvider } from "@/context/NotificationContext";
import { ScrollToTop } from "./components/ScrollToTop";
import { useEffect, useState } from "react";
import OfflinePage from "./pages/offline/OfflinePage";

// Mantine theme configuration
function App() {
  const [isOnline, setIsOnline] = useState(window.navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (!isOnline) {
    return <OfflinePage />;
  }

  return (
    <>
      <Notifications position="top-right" zIndex={1000} />
      <BrowserRouter
        future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
      >
        <UserProvider>
          <NotificationProvider>
            <ScrollToTop />
            <AppRoutes />
          </NotificationProvider>
        </UserProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
